export const initRegionRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/regions",
          name: "region",
          component: () => import("@/pages/manage/regions/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [
              config.roles.administrators,
              config.roles.siteEditors,
              config.roles.customerService,
            ],
          },
        },
        {
          path: "/manage/regions/:id",
          name: "region-id",
          component: () => import("@/pages/manage/regions/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [
              config.roles.administrators,
              config.roles.siteEditors,
              config.roles.customerService,
            ],
          },
        },
      ];
